/**
 * FaithPire - Revelation Capsule Product JavaScript
 * Handles image gallery, variant selection, and interactive features
 */

(function() {
  'use strict';

  // ============================================
  // Image Gallery Functionality
  // ============================================
  
  const initGallery = () => {
    const mainImage = document.getElementById('revelation-featured-image');
    const thumbnails = document.querySelectorAll('.revelation-thumb');
    
    if (!mainImage || thumbnails.length === 0) return;
    
    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', function() {
        // Get the image source from the clicked thumbnail
        const thumbImg = this.querySelector('img');
        if (!thumbImg) return;
        
        // Update main image
        const fullSizeSrc = thumbImg.src.replace(/width=\d+/, 'width=1200');
        mainImage.src = fullSizeSrc;
        mainImage.alt = thumbImg.alt;
        
        // Update active state
        thumbnails.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
      });
    });
  };

  // ============================================
  // Variant Selection & Form Handling
  // ============================================
  
  const initVariantSelection = () => {
    const form = document.querySelector('.revelation-form');
    if (!form) return;
    
    const colorInputs = form.querySelectorAll('input[name="options[Color]"], input[name="options[Colour]"]');
    const sizeInputs = form.querySelectorAll('input[name="options[Size]"]');
    const variantIdInput = form.querySelector('input[name="id"]');
    const priceElement = document.querySelector('.revelation-price .money');
    const addToCartBtn = form.querySelector('button[type="submit"]');
    
    // Update selected color display
    colorInputs.forEach(input => {
      input.addEventListener('change', function() {
        const label = document.querySelector('.revelation-option-label .revelation-selected-value');
        if (label) {
          label.textContent = this.value;
        }
        updateVariant();
      });
    });
    
    // Size selection
    sizeInputs.forEach(input => {
      input.addEventListener('change', updateVariant);
    });
    
    // Update variant based on selected options
    function updateVariant() {
      const selectedOptions = {};
      
      // Get selected color
      const selectedColor = form.querySelector('input[name="options[Color]"]:checked, input[name="options[Colour]"]:checked');
      if (selectedColor) {
        selectedOptions.Color = selectedColor.value;
      }
      
      // Get selected size
      const selectedSize = form.querySelector('input[name="options[Size]"]:checked');
      if (selectedSize) {
        selectedOptions.Size = selectedSize.value;
      }
      
      // Find matching variant (this would need to be enhanced with actual variant data from Shopify)
      // For now, we'll just update the button state based on size selection
      if (selectedSize && addToCartBtn) {
        addToCartBtn.disabled = false;
        addToCartBtn.querySelector('span').textContent = 'Add to Cart';
      }
    }
    
    // Form submission
    form.addEventListener('submit', function(e) {
      const selectedSize = form.querySelector('input[name="options[Size]"]:checked');
      
      if (!selectedSize) {
        e.preventDefault();
        showToast('Please select a size', 'error');
        
        // Scroll to size selector
        const sizeSection = form.querySelector('.revelation-size-buttons');
        if (sizeSection) {
          sizeSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });
  };

  // ============================================
  // Size Guide Modal
  // ============================================
  
  const initSizeGuide = () => {
    const sizeGuideTriggers = document.querySelectorAll('.revelation-size-guide-trigger');
    const modal = document.getElementById('revelation-size-guide-modal');
    const modalClose = document.querySelector('.revelation-modal-close');
    const modalOverlay = document.querySelector('.revelation-modal-overlay');
    const sizeGuideData = document.getElementById('revelation-size-guide-data');
    
    if (!modal || sizeGuideTriggers.length === 0) return;
    
    // Size guide data (this matches your theme settings structure)
    const sizeGuides = {
      hoodie: `
        <div class="revelation-size-table">
          <table>
            <thead>
              <tr>
                <th>Size</th>
                <th>Chest (in)</th>
                <th>Length (in)</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>XS</td><td>20</td><td>26</td></tr>
              <tr><td>S</td><td>22</td><td>27</td></tr>
              <tr><td>M</td><td>24</td><td>28</td></tr>
              <tr><td>L</td><td>26</td><td>29</td></tr>
              <tr><td>XL</td><td>28</td><td>30</td></tr>
              <tr><td>XXL</td><td>30</td><td>31</td></tr>
            </tbody>
          </table>
        </div>
      `,
      tshirt: `
        <div class="revelation-size-table">
          <table>
            <thead>
              <tr>
                <th>Size</th>
                <th>Chest (in)</th>
                <th>Length (in)</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>XS</td><td>18</td><td>27</td></tr>
              <tr><td>S</td><td>20</td><td>28</td></tr>
              <tr><td>M</td><td>22</td><td>29</td></tr>
              <tr><td>L</td><td>24</td><td>30</td></tr>
              <tr><td>XL</td><td>26</td><td>31</td></tr>
              <tr><td>XXL</td><td>28</td><td>32</td></tr>
            </tbody>
          </table>
        </div>
      `,
      hat: `
        <div class="revelation-size-table">
          <table>
            <thead>
              <tr>
                <th>Size</th>
                <th>Head Circumference (in)</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>One Size</td><td>21-24</td></tr>
            </tbody>
          </table>
        </div>
      `
    };
    
    // Open modal
    sizeGuideTriggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        const guideType = this.dataset.sizeGuide;
        
        if (sizeGuides[guideType]) {
          sizeGuideData.innerHTML = sizeGuides[guideType];
          modal.style.display = 'flex';
          document.body.style.overflow = 'hidden';
        }
      });
    });
    
    // Close modal
    const closeModal = () => {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    };
    
    if (modalClose) {
      modalClose.addEventListener('click', closeModal);
    }
    
    if (modalOverlay) {
      modalOverlay.addEventListener('click', closeModal);
    }
    
    // Close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.style.display === 'flex') {
        closeModal();
      }
    });
  };

  // ============================================
  // Toast Notification (for errors/success)
  // ============================================
  
  const showToast = (message, type = 'info') => {
    // Remove any existing toast
    const existingToast = document.querySelector('.revelation-toast');
    if (existingToast) {
      existingToast.remove();
    }
    
    // Create toast element
    const toast = document.createElement('div');
    toast.className = `revelation-toast revelation-toast-${type}`;
    toast.textContent = message;
    
    // Add styles
    toast.style.cssText = `
      position: fixed;
      bottom: 2rem;
      right: 2rem;
      background-color: ${type === 'error' ? '#dc2626' : '#059669'};
      color: white;
      padding: 1rem 1.5rem;
      border-radius: 4px;
      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
      z-index: 10000;
      font-size: 0.875rem;
      font-weight: 600;
      animation: slideInRight 0.3s ease-out;
    `;
    
    document.body.appendChild(toast);
    
    // Auto remove after 3 seconds
    setTimeout(() => {
      toast.style.animation = 'slideOutRight 0.3s ease-out';
      setTimeout(() => toast.remove(), 300);
    }, 3000);
  };
  
  // Add animation styles
  const addToastStyles = () => {
    if (document.getElementById('revelation-toast-styles')) return;
    
    const style = document.createElement('style');
    style.id = 'revelation-toast-styles';
    style.textContent = `
      @keyframes slideInRight {
        from {
          transform: translateX(100%);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
      
      @keyframes slideOutRight {
        from {
          transform: translateX(0);
          opacity: 1;
        }
        to {
          transform: translateX(100%);
          opacity: 0;
        }
      }
      
      .revelation-size-table {
        background-color: rgba(26, 35, 52, 0.3);
        padding: 1.5rem;
        border-radius: 2px;
        overflow-x: auto;
      }
      
      .revelation-size-table table {
        width: 100%;
        border-collapse: collapse;
      }
      
      .revelation-size-table th,
      .revelation-size-table td {
        padding: 0.75rem;
        text-align: center;
        border-bottom: 1px solid rgba(169, 164, 137, 0.2);
      }
      
      .revelation-size-table th {
        font-size: 0.75rem;
        text-transform: uppercase;
        letter-spacing: 0.1em;
        color: var(--olive-sand);
        font-weight: 700;
        border-bottom: 1px solid rgba(169, 164, 137, 0.3);
      }
      
      .revelation-size-table td {
        color: var(--anointed-cream);
      }
      
      .revelation-size-table tbody tr:hover {
        background-color: rgba(255, 255, 255, 0.05);
      }
    `;
    document.head.appendChild(style);
  };

  // ============================================
  // Smooth Scroll for Internal Links
  // ============================================
  
  const initSmoothScroll = () => {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href === '#') return;
        
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  };

  // ============================================
  // Lazy Load Images (for better performance)
  // ============================================
  
  const initLazyLoad = () => {
    const images = document.querySelectorAll('img[loading="lazy"]');
    
    if ('loading' in HTMLImageElement.prototype) {
      // Browser supports native lazy loading
      return;
    }
    
    // Fallback for browsers that don't support native lazy loading
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src || img.src;
          img.classList.add('loaded');
          observer.unobserve(img);
        }
      });
    });
    
    images.forEach(img => imageObserver.observe(img));
  };

  // ============================================
  // Initialize All Features
  // ============================================
  
  const init = () => {
    // Wait for DOM to be fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    
    initGallery();
    initVariantSelection();
    initSizeGuide();
    initSmoothScroll();
    initLazyLoad();
    addToastStyles();
    
    console.log('✨ FaithPire Revelation Product Page Initialized');
  };
  
  // Start initialization
  init();

})();